



















import { Component, Mixins } from "vue-property-decorator";
import HelperDinamicallyForm from "@/components/DinamicallyForm/HelperDinamicallyForm";
import ticketModule from "@/store/modules/ticket-module";
import { ticket } from "@/shared/dtos/ticket";
import usuarioModule from "@/store/modules/usuario-module";
import enumeracionModule from "@/store/modules/enumeracion-module";
import { enumeracion } from "@/shared/dtos/enumeracion";
import { UtilsString } from "@/utils/utils-string";

@Component({
  components: {},
})
export default class TicketsFormularioUser extends Mixins(
  HelperDinamicallyForm
) {
  public item_pantalla: ticket = new ticket();
  public categoria: enumeracion[] = [];
  public prioridades: enumeracion[] = [];
  public estado: enumeracion[] = [];

  public async OnCreated() {
    await usuarioModule.getusuarios();
    await enumeracionModule.getenumeraciones_fromtipo(4).then((x) => {
      this.prioridades = x.enumeraciones;
    });
    await enumeracionModule.getenumeraciones_fromtipo(5).then((x) => {
      this.categoria = x.enumeraciones;
    });
    await enumeracionModule.getenumeraciones_fromtipo(6).then((x) => {
      this.estado = x.enumeraciones;
    });

    if (this.getparamId().HayParametro) {
      await ticketModule.getticket(this.getparamId().Parametro);
      this.item_pantalla = ticketModule.ticket;
    } else {
      this.item_pantalla.fecha_inicio = new Date();
    }
    //Para la clonacion automatica
    this.BasicElement = this.item_pantalla;
  }

  public CreateFields() {
    //Empezamos a crear una pantalla
    //configuracion de la clonacion automatica

    this.AddFormItemDataDefaultString(
      this.item_pantalla.nombre,
      "Nombre",
      "nombre",
      60
    )
      .isRequired()
      .Dimesiones(12, 6, 4)
      .isReadOnly(!this.EstoyCreado);

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.id_categoria,
      "Categoría",
      "id_categoria"
    )
      .Dimesiones(12, 6, 4)
      .CreateComboSingle(this.categoria, "nombre")
      .isReadOnly(!this.EstoyCreado);

    this.AddFormItemDataDefaultNumber(
      this.item_pantalla.id_estado,
      "Estado",
      "id_estado"
    )
      .Dimesiones(12, 6, 3)
      .CreateComboSingle(this.estado, "nombre")
      .isReadOnly()
      .isVisible(!this.EstoyCreado);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.descripcion,
      "Descripción",
      "descripcion"
    )
      .isRequired()
      .CreateTextArea()
      .isReadOnly(!this.EstoyCreado);
    this.AddFormItemDataDefaultDate(
      new Date(this.item_pantalla.fecha_inicio),
      "Fecha inicio",
      "fecha_inicio"
    )
      .Dimesiones(12, 6, 3)
      .isRequired()
      .isReadOnly();

    this.AddFormItemDataDefaultDate(
      new Date(this.item_pantalla.fecha_fin),
      "Última actualización del caso",
      "fecha_fin"
    )
      .Dimesiones(12, 6, 3)
      .isReadOnly()
      .isVisible(new Date(this.item_pantalla.fecha_fin).getFullYear() > 0);

    this.AddFormItemDataDefaultString(
      this.item_pantalla.resolucion,
      "Resolución",
      "resolucion"
    )
      .CreateTextArea()
      .isReadOnly()
      .isVisible(UtilsString.ValueOf(this.item_pantalla.resolucion).length > 0);
  }

  public Insertar(object: ticket) {
    object.fecha_fin = new Date();
    ticketModule.guardarticket(object).then(() => {
      this.AllSaveOk();
    });
  }

  public Actualizar(object: ticket) {
    ticketModule.modificarticket(object).then(() => {
      this.AllSaveOk();
    });
  }
}
